import React, { useState, useEffect, useRef } from 'react';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import HelpSite from "../../../Common/HelpLink";
import BASE_URL from "../../../../config/config";
import CompanySetupController from "../../../SuperAdmin/Controller/Client/SACompanyListController";
function DatabasePage() {
    const HelpLink = localStorage.getItem('HelpLink');
    const [DatabaseBackup, setDatabaseBackup] = useState('0');
    const [loading, setLoading] = useState(false);
      const [selectedFile, setSelectedFile] = useState(null);
    const fetchDownloadBackup = async () => {
        try {
            const dbBackup = await CompanySetupController.DownloadDatabaseBackup();
            setDatabaseBackup(dbBackup?.[0]?.UserID ?? 0);

        } catch (error) {
            console.error('Error fetching currencies:', error);
        }
    };
    const handleDownloadBackup = async () => {
        try {
            setLoading(true);
            const response = await CompanySetupController.DownloadBackup();
            if (response.data) {
                Swal.fire(
                    'Success!',
                    'Backup request submitted. Please check status later.',
                    'success'
                );
            }

        } catch (err) {
            console.error('Error downloading backup:', err);
            //alert('Failed to download backup');
        }
        finally {
            setLoading(false);
        }
    };
     const handleRestoreFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };
    const handleRestoreBackup = async () => {
    if (!selectedFile) {
      alert("Please select a backup file (.sql)");
      return;
    }

    try {
      setLoading(true);
      const postData = await CompanySetupController.RestoreDatabaseBackup(selectedFile);
      if (postData.message === "Data Saved Successfully") {
        Swal.fire(
          'Success!',
          'Database restored successfully.',
          'success'
        );
      }

    } catch (err) {
      console.error('Error restoring backup:', err);
      Swal.fire('Error', 'Failed to restore backup.', 'error');
    } finally {
      setLoading(false);
    }
  };
    useEffect(() => {
        fetchDownloadBackup();
    }, []);
    return (
        <div>
            {loading && (
                <div class="loading">
                    <div class="d-table">
                        <div class="d-tablecell">
                            <span class="loader">
                                <span class="loader-inner"></span>
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <div className="row mb-3">
                <div className="col-sm-12" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Database Maintenance" Module="26" />
                </div>
            </div>
            <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                <label for="inputText" className="col-sm-2 col-form-label">Restore:</label>
                <div className="col-sm-3">
                    <input type="file" className="form-control file-control" name="File" onChange={handleRestoreFileChange} />
                </div>
                <div className="col-sm-1">
                    <button type="button" style={{ "float": "right" }} className="btn btn-warning" onClick={handleRestoreBackup}>
                        Restore
                    </button>
                </div>

            </div>
        </div>
    );
}

export default DatabasePage;
